import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";

export const createManager = async (domain: string, newManagerData: ManagerFormValuesProps): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop-manager`,
        method: 'POST',
        params: newManagerData,
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}